import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from 'react';
import { getPartners } from '../../actions/ActionPartnerWL';

export const PartnerListContext = createContext({});

export const PartnerListProvider = ({ children }) => {
	const [aPartners, setPartners] = useState([]);
	const [bIsLoading, setLoading] = useState(false);

	const getPartnerItems = useCallback(async () => {
		// customer/subscription-change

		if (bIsLoading) return;

		setLoading(true);

		try {
			const { aPartners: aNewPartners } = await getPartners();
			setPartners(aNewPartners);
		} catch (oError) {
			console.log(oError);
		} finally {
			setLoading(false);
		}
	}, [bIsLoading]);

	// carrega os parceiros a primeira vez
	useEffect(() => {
		getPartnerItems();
	}, []);

	const oValues = useMemo(
		() => ({
			aPartners,
			bIsLoading,
			getPartners: getPartnerItems,
		}),
		[aPartners, bIsLoading, getPartnerItems]
	);

	return <PartnerListContext.Provider value={oValues}>{children}</PartnerListContext.Provider>;
};

export const usePartnerListContext = () => useContext(PartnerListContext);